// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"b8c6446d","399":"6b9fc383","992":"9246273b"}[chunkId] + ".chunk.css";
};